// src/components/charts/BarChart.js
import React from "react";
import Chart from "react-apexcharts";

export default function BarChart({ chartData, chartOptions }) {
  // 🔒 ApexCharts 안전 가드
  if (!chartData || chartData.length === 0) return null;

  return (
    <Chart
      options={chartOptions}
      series={chartData}
      type="bar"
      width="100%"
      height="100%"
    />
  );
}